import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

import { Badge } from "@/components/kit";
import { C, date, eur, PROJECT_LABELS, STATUS_LABELS, statusColor } from "@/lib/format";

export function DossierItem({ d, admin }) {
  return (
    <Link
      to={admin ? `/admin/dossier/${d.id}` : `/dossier/${d.id}`}
      data-testid={`dossier-item-${d.number}`}
      className="pressable flex flex-col gap-1 rounded-[20px] border border-[#333333] bg-[#1E1E1E] p-4"
    >
      <div className="flex justify-between">
        <span className="t-caption tracking-[1px] !text-[#D4AF37]">{d.number}</span>
        <span className="t-caption">{date(d.created_at)}</span>
      </div>
      <h3 className="t-h3 truncate">
        {d.client.first_name} {d.client.last_name}
      </h3>
      <p className="t-caption truncate">
        {PROJECT_LABELS[d.project_type]} · {d.city}
        {d.budget ? ` · ${eur(d.budget)}` : ""}
        {admin && d.agent_name ? ` · par ${d.agent_name}` : ""}
      </p>
      <div className="mt-2 flex items-center justify-between">
        <Badge label={STATUS_LABELS[d.status]} color={statusColor(d.status)} />
        {d.commission_amount ? (
          <span className="t-h3 tabular-nums !text-[#27AE60]">{eur(d.commission_amount)}</span>
        ) : (
          <ChevronRight className="h-[18px] w-[18px]" style={{ color: C.muted }} aria-hidden />
        )}
      </div>
      {admin && d.assigned_to ? <p className="t-caption !text-[#C0C0C0]">Attribué à {d.assigned_to.name}</p> : null}
      {admin ? (
        <p data-testid={`dossier-item-master-${d.number}`} className={`t-caption truncate ${d.master ? "!text-[#C0C0C0]" : "!text-[#F2994A]"}`}>
          Maître d'œuvre : {d.master?.company_name ?? "à attribuer"}
        </p>
      ) : null}
    </Link>
  );
}
